import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {MessageTemplateList} from "../../models/messageTemplateList";
import {MessageTemplateService} from "../../services/messageTemplate.service";

@Injectable()
export class MessageTemplatesResolve implements Resolve<MessageTemplateList> {
    constructor(private messageTemplateService: MessageTemplateService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<MessageTemplateList> {
        return this.messageTemplateService.getAll(0, 100);
    }
}
